// extracted by mini-css-extract-plugin
export default {"thumbnailsProduct":"ThumbnailsProduct_thumbnailsProduct__3WnZb","designerName":"ThumbnailsProduct_designerName__NN70-","productTitle":"ThumbnailsProduct_productTitle__n5zAR"};